import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const Determination = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  return (
    <Stack>
      <Typography variant='body6'>{dictionary.steps.step5.info1}</Typography>
      <Typography variant='body6' sx={{ mb: '20px' }}>
        {dictionary.steps.step5.info2}
      </Typography>
      <Typography variant='body6'>{dictionary.steps.step5.info3}</Typography>
    </Stack>
  );
};
